import API from 'api/clients'
import { queryService } from 'modules/module-api'
import { all, fork } from 'redux-saga/effects'

import SettingSaga from './SettingsSaga'

export default function* settingsSagas() {
  yield all([fork(new SettingSaga(API, queryService).supervise)])
}
